import format from 'date-fns/format';
import { placementTags } from './constants';
import { PlacementTag } from './types';

export const formatDate = (
  editorialUpdateDate: string | null | undefined,
): string => {
  if (!editorialUpdateDate) {
    return 'January 1, 1970';
  }

  return format(new Date(editorialUpdateDate), 'MMMM d, yyyy');
};

export function isPlacementTag(tag: string): tag is PlacementTag {
  return (
    tag === placementTags[0] ||
    tag === placementTags[1] ||
    tag === placementTags[2]
  );
}
